module.exports = __webpack_public_path__ + "img/domijn3.c149fb1b.jpg";